import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function MinAmountModal({ show, onClose, minAmount }) {
  if (!show) return null;

  return (
    <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">Amount Too Low</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p>Please enter an amount of ₹{minAmount} or more.</p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-danger" onClick={onClose}>
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}